import $ from 'jquery';

const DomUtils = {
  // this generates onBlur handler for use with anytype of popup dropdowns
  genBlurHandler: (popupClass, onCloseHandler, ignoreClass = '') => {
    const parentClassSelector = `.${popupClass}`;
    return (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (
        $.contains(e.target, e.relatedTarget)
        || (e.relatedTarget
          && !e.relatedTarget.classList.contains(ignoreClass)
          && ($.contains(e.relatedTarget, e.target)
            || $(e.target).closest(parentClassSelector).has(e.relatedTarget)[0]))
      ) {
        // nothing to do
      } else {
        const target = $(e.target).find(parentClassSelector)[0]
          ? $(e.target).find(parentClassSelector)
          : $(e.target).closest(parentClassSelector);
        if (typeof onCloseHandler === 'function') {
          onCloseHandler(target);
        }
      }
    };
  },

  /**
   * Check if el is in view\
   *
   * @param el
   * @returns {boolean|boolean}
   */
  isElementInViewport: (el) => {
    // Special bonus for those using jQuery
    if (typeof jQuery === 'function' && el instanceof jQuery) {
      el = el[0];
    }
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0
      && rect.left >= 0
      && rect.bottom
        <= (window.innerHeight || document.documentElement.clientHeight)
      /* or $(window).height() */ && rect.right
        <= (window.innerWidth
          || document.documentElement.clientWidth) /* or $(window).width() */
    );
  },
};
export default DomUtils;
